<template lang="pug">
div
    div(
        ref="videoEl"
        class="wistia_responsive_padding relative"
        :class="{'customLink':$slots.default}"
        style="padding-top: 56.25%;"
    )
        div(class="wistia_responsive_wrapper customLink_wrapper absolute left-0 top-0 h-full w-full")
            span(:class="[cssClass, {'popoverContent=Link':$slots.default}]")
                slot &nbsp;
    div(
        v-if="video.title && !$slots.default"
        class="mt-3 text-xs md:text-sm"
    )
        div(v-html="video.title" class="font-bold")
        div(v-if="video.duration" class="text-gray-dark")
            | {{ durationToClock(video.duration) }}

    VideoSchema(:video="video")

</template>
<script>
import VideoSchema from '@/components/videoSchema.vue'
import { durationToClock } from '@/helpers/filters'
import { intersectionObserverMixin } from '@/helpers/intersectionObserverMixin'
import wistiaMixin from './mixin'

export default {
    components: {
        VideoSchema,
    },
    mixins: [wistiaMixin, intersectionObserverMixin],
    props: {
        video: {
            type: Object,
            required: true,
        },
    },
    computed: {
        cssClass() {
            return `wistia_embed wistia_async_${this.video.id} seo=false popover=true popoverAnimateThumbnail=true videoFoam=true relative inline-block h-full w-full`
        },
        activeOverlay() {
            return this.$overlay.state.activeOverlay
        },
    },
    watch: {
        activeOverlay(newVal) {
            // If the video is in a Modal/Panel close it
            if (newVal == null) this.close()
        },
    },
    mounted() {
        this.observeOnce(this.$refs.videoEl, this.loadWistiaVideo)
    },
    beforeDestroy() {
        // If this component is destroyed, close the wistia video
        this.close()
    },
    methods: {
        durationToClock,
        close() {
            // wrapped in a try because on staging, when the api was giving us a bad id (was a full jsonp url ) the api returned 'something' instead of null, but was exploding when we called popover.hide()
            if (typeof window.Wistia !== 'undefined') {
                try {
                    window.Wistia.api(this.video.id).popover.hide()
                } catch (e) {
                    console.log(`wistia close error for video id [${this.video.id}]`)
                }
            }
        },
    },
}
</script>

<style lang="stylus" scoped>
.customLink
    padding 0 !important
    position relative
    .customLink_wrapper
        position relative
        >>> .wistia_click_to_play
            width 100% !important
            height 100% !important
</style>
